export default __webpack_public_path__ + "static/media/sequence_t_left.02e5a773.png";